var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_111_report_analysis_flatline",
    "data-name": "#111_report_analysis_flatline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.69,163l3-70.13s-12.43,4.69-20.25-2.6l4.23,78.89Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.7,169.64a.43.43,0,0,1-.25-.07.48.48,0,0,1-.25-.4L306,90.28a.5.5,0,0,1,.29-.48.49.49,0,0,1,.55.09c7.5,7,19.61,2.53,19.73,2.49a.49.49,0,0,1,.47.06.52.52,0,0,1,.21.43l-3,70.13a.5.5,0,0,1-.29.43l-13,6.16A.42.42,0,0,1,310.7,169.64ZM307,91.4l4.13,77,12-5.71,3-69.1C323.51,94.41,314,96.88,307,91.4ZM323.69,163h0Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.62,
    cy: 91.37,
    rx: 5.97,
    ry: 10.21,
    transform: "matrix(0.13, -0.99, 0.99, 0.13, 185.76, 393.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.08,97.93a16.49,16.49,0,0,1-2-.11c-6-.65-10.41-4-10.14-7.6a4.6,4.6,0,0,1,1.79-3.2c2.09-1.74,5.58-2.52,9.36-2.1,6,.65,10.41,4,10.14,7.6a4.6,4.6,0,0,1-1.79,3.2A11.68,11.68,0,0,1,318.08,97.93ZM315.2,85.81a10.87,10.87,0,0,0-6.8,2,3.6,3.6,0,0,0-1.43,2.5c-.23,3,3.92,5.95,9.25,6.54,3.46.38,6.76-.34,8.61-1.87a3.66,3.66,0,0,0,1.43-2.51c.23-3-3.92-6-9.25-6.54A15.93,15.93,0,0,0,315.2,85.81Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.59,97.7a.5.5,0,0,1-.14-1,9.72,9.72,0,0,0,3.09-1.5,3.9,3.9,0,0,0,1.81-2.72,3.81,3.81,0,0,0-1-2.56,6.35,6.35,0,0,0-4.48-2.24A9.45,9.45,0,0,0,313,88.94a3,3,0,0,0-1.83,2,2.5,2.5,0,0,0,.6,1.94,4.27,4.27,0,0,0,1.68,1.1l.24.09.1-3.93a.48.48,0,0,1,.24-.41,6.08,6.08,0,0,1,5.42-.46,3.15,3.15,0,0,1,1.22.81,3.27,3.27,0,0,1,.45,3.1,3.68,3.68,0,0,1-2,2.1,5.25,5.25,0,0,1-2.51.4,10.78,10.78,0,0,1-3.57-.77A5.21,5.21,0,0,1,311,93.57a3.57,3.57,0,0,1-.83-2.74,3.92,3.92,0,0,1,2.35-2.78A10.42,10.42,0,0,1,318,86.7a7.31,7.31,0,0,1,5.18,2.6,4.25,4.25,0,0,1-1,6.73,10.61,10.61,0,0,1-3.4,1.65Zm-3.94-3.27a9.11,9.11,0,0,0,2,.29,4.39,4.39,0,0,0,2.06-.31,2.69,2.69,0,0,0,1.43-1.53,2.27,2.27,0,0,0-.27-2.11,2,2,0,0,0-.83-.53,5.1,5.1,0,0,0-4.3.25Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.12,160.86l10.45-69.08s-12.82,2.73-19.81-5.7L327.59,165Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.59,165.47a.51.51,0,0,1-.31-.11.48.48,0,0,1-.19-.42l4.17-78.89a.51.51,0,0,1,.34-.45.52.52,0,0,1,.55.16c6.71,8.1,19.19,5.56,19.31,5.53a.49.49,0,0,1,.45.12.51.51,0,0,1,.15.44l-10.44,69.09a.5.5,0,0,1-.35.4l-13.54,4.11Zm4.61-78.16-4.08,77,12.56-3.81L351,92.39C348.27,92.79,338.43,93.73,332.2,87.31Zm8.92,73.55h0Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 341.7,
    cy: 88.75,
    rx: 5.91,
    ry: 10.31,
    transform: "translate(155.26 388.55) rotate(-72.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.88,95.68a16.85,16.85,0,0,1-4.38-.61c-5.83-1.56-9.88-5.56-9.23-9.08a4.32,4.32,0,0,1,2.09-2.89c2.25-1.42,5.82-1.67,9.55-.67,5.83,1.57,9.88,5.56,9.23,9.09h0a4.4,4.4,0,0,1-2.09,2.89A9.78,9.78,0,0,1,344.88,95.68Zm-6.34-12.85a8.91,8.91,0,0,0-4.65,1.11,3.36,3.36,0,0,0-1.64,2.23c-.55,3,3.27,6.53,8.51,7.94,3.41.92,6.77.71,8.76-.55a3.36,3.36,0,0,0,1.64-2.22h0c.55-3-3.27-6.54-8.51-7.94A15.94,15.94,0,0,0,338.54,82.83Zm13.11,8.6h0Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,95.34a.51.51,0,0,1-.5-.44.51.51,0,0,1,.44-.56,9.11,9.11,0,0,0,3.21-1,3.63,3.63,0,0,0,2.07-2.39,4,4,0,0,0-.71-2.71,6.73,6.73,0,0,0-4.21-2.92,9.22,9.22,0,0,0-5,.46c-1.15.4-1.81,1-2,1.73a2.61,2.61,0,0,0,.39,2,4.76,4.76,0,0,0,1.56,1.36l.22.12.51-3.85a.5.5,0,0,1,.3-.4,6.1,6.1,0,0,1,5.42.38,3.14,3.14,0,0,1,1.11,1,3.27,3.27,0,0,1,.11,3.13,3.51,3.51,0,0,1-2.18,1.8,5.27,5.27,0,0,1-2.54,0,11.09,11.09,0,0,1-3.45-1.32,5.45,5.45,0,0,1-1.89-1.67,3.62,3.62,0,0,1-.53-2.84A3.7,3.7,0,0,1,338,84.83a10.16,10.16,0,0,1,5.56-.5,7.8,7.8,0,0,1,4.85,3.36,5,5,0,0,1,.85,3.42,4.52,4.52,0,0,1-2.6,3.11,10.35,10.35,0,0,1-3.55,1.12Zm-3.61-3.87a10.31,10.31,0,0,0,2,.62,4.41,4.41,0,0,0,2.08,0A2.52,2.52,0,0,0,345,90.82a2.27,2.27,0,0,0,0-2.14,2,2,0,0,0-.78-.67,5.11,5.11,0,0,0-4.27-.43Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.14,176.45l-.35-70.22s12.23,5.37,20.33-1.47l-7.24,78.57Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.88,183.83a.48.48,0,0,1-.24-.06l-12.74-6.88a.48.48,0,0,1-.26-.43l-.35-70.23a.5.5,0,0,1,.23-.42.51.51,0,0,1,.48,0c.11,0,12,5.17,19.79-1.39a.52.52,0,0,1,.56-.06.53.53,0,0,1,.27.49l-7.25,78.57a.49.49,0,0,1-.26.4A.46.46,0,0,1,326.88,183.83Zm-12.24-7.67,11.81,6.38,7.06-76.67C326.39,111,317,108,314.3,107Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 323.94,
    cy: 105.32,
    rx: 10.19,
    ry: 5.98,
    transform: "translate(-5.98 20.59) rotate(-3.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.2,111.82c-3.39,0-6.43-1-8.27-2.64a4.7,4.7,0,0,1-1.67-3.3c-.13-3.62,4.45-6.72,10.43-7,3.78-.21,7.24.77,9.26,2.61a4.73,4.73,0,0,1,1.67,3.3c.13,3.56-4.55,6.72-10.43,7Q323.7,111.82,323.2,111.82Zm1.45-12-.91,0c-5.34.29-9.59,3-9.48,6a3.77,3.77,0,0,0,1.34,2.59c1.8,1.64,5.07,2.54,8.53,2.35,5.35-.29,9.6-3,9.49-6a3.75,3.75,0,0,0-1.35-2.59C330.64,100.69,327.77,99.81,324.65,99.81Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.75,111.53a.45.45,0,0,1-.16,0,11,11,0,0,1-3.33-1.83,4.88,4.88,0,0,1-2.09-3.58,4.64,4.64,0,0,1,1.34-3.2,7.2,7.2,0,0,1,5.28-2.31,10.69,10.69,0,0,1,5.39,1.65,4,4,0,0,1,2.24,2.89,3.49,3.49,0,0,1-.94,2.71,5.08,5.08,0,0,1-2.12,1.26,10.54,10.54,0,0,1-3.59.57,5.29,5.29,0,0,1-2.5-.54,3.8,3.8,0,0,1-1.87-2.2,3.23,3.23,0,0,1,.57-3.07,3,3,0,0,1,1.26-.75,6.14,6.14,0,0,1,5.39.76.5.5,0,0,1,.22.42l0,3.94.25-.08a4,4,0,0,0,1.71-1,2.44,2.44,0,0,0,.67-1.9,3.06,3.06,0,0,0-1.75-2.15,9.58,9.58,0,0,0-4.85-1.51h0a6.2,6.2,0,0,0-4.55,2,3.72,3.72,0,0,0-1.08,2.5,4,4,0,0,0,1.71,2.83,10.26,10.26,0,0,0,3,1.67.5.5,0,0,1-.16,1Zm1.39-7.74a4.86,4.86,0,0,0-1.59.26,1.85,1.85,0,0,0-.85.49,2.21,2.21,0,0,0-.34,2.08,2.77,2.77,0,0,0,1.37,1.62,4.46,4.46,0,0,0,2,.42,9,9,0,0,0,2-.18l.05-3.93A5.12,5.12,0,0,0,323.14,103.79Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.75,235.29H49.64a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H335.75a.5.5,0,0,1,.5.5A.5.5,0,0,1,335.75,235.29Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.46,146.93h48.93a0,0,0,0,1,0,0v83.67A9.42,9.42,0,0,1,341,240H310.89a9.42,9.42,0,0,1-9.42-9.42V146.93A0,0,0,0,1,301.46,146.93Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,240.52H310.89a9.94,9.94,0,0,1-9.93-9.93V146.93a.5.5,0,0,1,.5-.5h48.93a.5.5,0,0,1,.5.5v83.66A9.94,9.94,0,0,1,341,240.52Zm-39-93.09v83.16a8.94,8.94,0,0,0,8.93,8.93H341a8.94,8.94,0,0,0,8.92-8.93V147.43Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.04,
    y: 136.61,
    width: 12.91,
    height: 76.32,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,213.43H58a.5.5,0,0,1-.5-.5V136.61a.5.5,0,0,1,.5-.5H71a.5.5,0,0,1,.5.5v76.32A.5.5,0,0,1,71,213.43Zm-12.41-1H70.45V137.11H58.54Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.95,
    y: 121.53,
    width: 17.15,
    height: 76.32,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1,198.36H71a.5.5,0,0,1-.5-.5V121.53a.5.5,0,0,1,.5-.5H88.1a.5.5,0,0,1,.5.5v76.33A.5.5,0,0,1,88.1,198.36Zm-16.65-1H87.6V122H71.45Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1,
    y: 127.65,
    width: 29.62,
    height: 76.32,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.72,204.47H88.1a.5.5,0,0,1-.5-.5V127.65a.5.5,0,0,1,.5-.5h29.62a.5.5,0,0,1,.5.5V204A.5.5,0,0,1,117.72,204.47Zm-29.12-1h28.62V128.15H88.6Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.84,
    y: 177.84,
    width: 81.89,
    height: 63.28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.73,241.62H48.84a.5.5,0,0,1-.5-.5V177.84a.5.5,0,0,1,.5-.5h81.89a.51.51,0,0,1,.5.5v63.28A.51.51,0,0,1,130.73,241.62Zm-81.39-1h80.89V178.34H49.34Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.64,199.64H58a.5.5,0,0,1-.5-.5V186.43a.5.5,0,0,1,.5-.5h22.6a.5.5,0,0,1,.5.5v12.71A.5.5,0,0,1,80.64,199.64Zm-22.1-1h21.6V186.93H58.54Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.85,146.9A3.13,3.13,0,1,1,67,143.78,3.13,3.13,0,0,1,63.85,146.9Zm0-5.25A2.13,2.13,0,1,0,66,143.78,2.14,2.14,0,0,0,63.85,141.65Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.52,133.64a3.13,3.13,0,1,1,3.13-3.12A3.12,3.12,0,0,1,79.52,133.64Zm0-5.25a2.13,2.13,0,1,0,2.13,2.13A2.12,2.12,0,0,0,79.52,128.39Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.49,141.65H88.1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h22.39a.5.5,0,0,1,.5.5A.5.5,0,0,1,110.49,141.65Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1,152.85H71a.5.5,0,0,1,0-1H88.1a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.77,
    y: 74.16,
    width: 190.49,
    height: 145.54,
    rx: 13.31,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,220.2H118.08a13.83,13.83,0,0,1-13.81-13.81V87.47a13.83,13.83,0,0,1,13.81-13.81H282a13.82,13.82,0,0,1,13.81,13.81V206.39A13.83,13.83,0,0,1,282,220.2ZM118.08,74.66a12.82,12.82,0,0,0-12.81,12.81V206.39a12.83,12.83,0,0,0,12.81,12.81H282a12.82,12.82,0,0,0,12.81-12.81V87.47A12.82,12.82,0,0,0,282,74.66Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.56,
    y: 57.22,
    width: 144.91,
    height: 138.06,
    fill: "#FF663B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.58,195.77H104.45a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5H295.58a.5.5,0,0,1,.5.5A.5.5,0,0,1,295.58,195.77Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.02,
    cy: 206.35,
    r: 4.57,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,211.41a5.07,5.07,0,1,1,5.06-5.06A5.07,5.07,0,0,1,200,211.41Zm0-9.13a4.07,4.07,0,1,0,4.06,4.07A4.07,4.07,0,0,0,200,202.28Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.73,
    y: 240.99,
    width: 76.58,
    height: 8.17,
    rx: 3.8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.51,249.65h-69a4.29,4.29,0,0,1-4.29-4.29v-.58a4.29,4.29,0,0,1,4.29-4.29h69a4.3,4.3,0,0,1,4.3,4.29v.58A4.3,4.3,0,0,1,234.51,249.65Zm-69-8.16a3.29,3.29,0,0,0-3.29,3.29v.58a3.3,3.3,0,0,0,3.29,3.29h69a3.3,3.3,0,0,0,3.3-3.29v-.58a3.29,3.29,0,0,0-3.3-3.29Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.13 241.12 173.9 241.12 177.49 219.69 222.54 219.69 226.13 241.12",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.13,241.62H173.9a.49.49,0,0,1-.38-.18.46.46,0,0,1-.11-.4L177,219.61a.49.49,0,0,1,.49-.41h45a.5.5,0,0,1,.5.41L226.63,241a.52.52,0,0,1-.11.4A.53.53,0,0,1,226.13,241.62Zm-51.64-1h51l-3.42-20.42H177.91Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.7 230.41 223.26 223.95 222.54 219.69 177.49 219.69 175.7 230.41",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.7,230.91a.48.48,0,0,1-.36-.16.52.52,0,0,1-.14-.43l1.8-10.71a.49.49,0,0,1,.49-.41h45a.5.5,0,0,1,.5.41l.71,4.25a.51.51,0,0,1-.09.38.5.5,0,0,1-.34.2l-47.56,6.46Zm2.21-10.71-1.61,9.62,46.38-6.3-.56-3.32Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.08,
    y: 133.11,
    width: 13.91,
    height: 11.02,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.19,135.86H168.3a1,1,0,0,1,0-2h43.89a1,1,0,0,1,0,2Z",
    fill: "#fdffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,142.15H168.3a1,1,0,0,1,0-2H203a1,1,0,0,1,0,2Z",
    fill: "#fdffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.72,142a1.32,1.32,0,0,1-.28,0,1.51,1.51,0,0,1-1.05-.79l-1.31-2.53a1.5,1.5,0,1,1,2.66-1.38l.44.85,3-2.61a1.5,1.5,0,1,1,2,2.27l-4.46,3.85A1.47,1.47,0,0,1,146.72,142Z",
    fill: "#FF663B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.08,
    y: 152.35,
    width: 13.91,
    height: 11.02,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.19,155.1H168.3a1,1,0,0,1,0-2h43.89a1,1,0,0,1,0,2Z",
    fill: "#fdffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,161.4H168.3a1,1,0,0,1,0-2H203a1,1,0,0,1,0,2Z",
    fill: "#fdffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.72,161.2a1.33,1.33,0,0,1-.28,0,1.53,1.53,0,0,1-1.05-.78l-1.31-2.54a1.5,1.5,0,1,1,2.66-1.38l.44.85,3-2.61a1.5,1.5,0,1,1,2,2.27l-4.46,3.85A1.48,1.48,0,0,1,146.72,161.2Z",
    fill: "#FF663B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.47,132.57a18.07,18.07,0,0,0-1.75,1.75A18.79,18.79,0,0,0,221,145.59h8.27a10.68,10.68,0,0,1,2.26-5.42,10.35,10.35,0,0,1,1.75-1.75,10.63,10.63,0,0,1,5.42-2.25v-8.28A18.89,18.89,0,0,0,227.47,132.57Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.91,145.59a18.84,18.84,0,0,0-4.67-11.27l-5.85,5.85a10.76,10.76,0,0,1,2.25,5.42c0,.41.07.82.07,1.24s0,.83-.07,1.24a10.68,10.68,0,0,1-2.26,5.42,10.35,10.35,0,0,1-1.75,1.75,10.6,10.6,0,0,1-5.42,2.25,10.93,10.93,0,0,1-2.47,0,10.67,10.67,0,0,1-5.42-2.25,10.35,10.35,0,0,1-1.75-1.75,10.73,10.73,0,0,1-2.26-5.42H221a18.79,18.79,0,0,0,4.68,11.27,18.07,18.07,0,0,0,1.75,1.75,18.91,18.91,0,0,0,11.27,4.68c.41,0,.82,0,1.23,0s.83,0,1.24,0a18.89,18.89,0,0,0,11.27-4.68,17,17,0,0,0,1.75-1.75,18.79,18.79,0,0,0,4.68-11.27c0-.41,0-.82,0-1.24S258.94,146,258.91,145.59Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.49,132.57a18.92,18.92,0,0,0-11.28-4.68v8.28a10.67,10.67,0,0,1,5.43,2.25Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.64,138.92a.45.45,0,0,1-.31-.11,10.23,10.23,0,0,0-5.18-2.15.5.5,0,0,1-.44-.49v-8.28a.48.48,0,0,1,.16-.36.5.5,0,0,1,.37-.14,19.25,19.25,0,0,1,11.58,4.81.53.53,0,0,1,.17.36.49.49,0,0,1-.15.36L247,138.78A.52.52,0,0,1,246.64,138.92Zm-4.93-3.19a11.15,11.15,0,0,1,4.88,2l5.16-5.16a18.27,18.27,0,0,0-10-4.17Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,178.84H141.08a1,1,0,0,1,0-2H255a1,1,0,0,1,0,2Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.91,119H141.08a1,1,0,0,1-1-1V78.3a1,1,0,1,1,2,0V117h72.83a1,1,0,0,1,0,2Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.41,114.07A.91.91,0,0,1,145,114a1,1,0,0,1-.44-1.34c.34-.66,8.34-16.22,18.81-19.47,6-1.88,8.11,1.57,9.93,4.61,1.64,2.75,3.06,5.12,7.16,4.83,4.47-.32,7.07-4.78,9.58-9.1s5.24-9,10.06-8.82a98,98,0,0,0,12,0,1,1,0,1,1,.19,2,98.93,98.93,0,0,1-12.3,0c-3.6-.12-5.86,3.73-8.25,7.83-2.64,4.54-5.64,9.69-11.17,10.09-5.34.37-7.38-3-9-5.8-1.78-3-3.07-5.14-7.62-3.73-9.67,3-17.54,18.31-17.62,18.47A1,1,0,0,1,145.41,114.07Z",
    fill: "#fdffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,119h-32.1a1,1,0,0,1-1-1V83.21a1,1,0,0,1,1-1H262a1,1,0,0,1,1,1V118A1,1,0,0,1,262,119Zm-31.1-2H261V84.21h-30.1Z",
    fill: "#fdffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.72,119a1,1,0,0,1-1-1V83.21a1,1,0,0,1,2,0V118A1,1,0,0,1,243.72,119Z",
    fill: "#fdffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,93h-32.1a1,1,0,0,1,0-2H262a1,1,0,0,1,0,2Z",
    fill: "#fdffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.37,71.78A2.68,2.68,0,0,1,155.93,70c-1-2.3-2.66-8.66-2.53-10,.15-1.6.92-2,1.37-2,1-.16,2,.78,2.72,2.31a63.16,63.16,0,0,1,1.77,7.48.5.5,0,1,1-1,.19,66.77,66.77,0,0,0-1.71-7.27c-.55-1.27-1.31-1.78-1.65-1.72s-.46.48-.52,1.14c-.1,1,1.4,7,2.45,9.5a1.63,1.63,0,0,0,1.91,1.13c1.12-.3,2.11-1.82,1.79-4.55-.64-5.44-3.81-12.56-5.22-14.2a1.37,1.37,0,0,0-1.82-.45c-1,.6-1.55,2.52-.43,5.3a.5.5,0,0,1-.93.38c-1.34-3.35-.54-5.69.84-6.53a2.36,2.36,0,0,1,3.1.65c1.7,2,4.82,9.37,5.45,14.73.4,3.33-1,5.23-2.52,5.64A2.46,2.46,0,0,1,158.37,71.78Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.02,
    y: 153.87,
    width: 10.89,
    height: 7.81,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.91,162.18H334a.5.5,0,0,1-.5-.5v-7.81a.5.5,0,0,1,.5-.5h10.89a.5.5,0,0,1,.5.5v7.81A.5.5,0,0,1,344.91,162.18Zm-10.39-1h9.89v-6.81h-9.89Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.22,
    y: 74.16,
    width: 28.56,
    height: 28.56,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.78,103.22H61.22a.51.51,0,0,1-.5-.5V74.16a.5.5,0,0,1,.5-.5H89.78a.5.5,0,0,1,.5.5v28.56A.5.5,0,0,1,89.78,103.22Zm-28.06-1H89.28V74.66H61.72Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.94,81H66.47a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H84.94a.51.51,0,0,1,.5.5A.5.5,0,0,1,84.94,81Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.94,86.17H66.47a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H84.94a.5.5,0,0,1,.5.5A.51.51,0,0,1,84.94,86.17Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.94,91.32H66.47a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H84.94a.51.51,0,0,1,.5.5A.5.5,0,0,1,84.94,91.32Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.52,96.48h-13A.5.5,0,0,1,66,96a.5.5,0,0,1,.5-.5h13a.5.5,0,0,1,.5.5A.5.5,0,0,1,79.52,96.48Z",
    fill: "#d1d3d4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.05ed3eeb2ccec9fbc1f87de3d0941349.svg";
export { ForwardRef as ReactComponent };